/**
 * Created by Qingger Corp.
 * User: yangzihua
 * Date: 2019/6/14
 * Time: 11:26
 * Desc: 试穿及出样设置-其他设置
 */

import { Component, Vue } from 'vue-property-decorator';
import { IPSService } from '@/services/ipsServices';

@Component
export default class ExtendedSetting extends Vue {
  /* 数据 */

  /**
   * 其他设置表单
   * @type {ItemObject}
   */
  public extendedSettingForm: ItemObject = {
    printDesc: '',
  };

  /* 方法 */

  /**
   * 获取集团顾客试穿和导购出样配置信息
   * @return null
   */
  public getGroupConfig(): void {
    IPSService.getGroupConfig({}).then((res) => {
      this.extendedSettingForm.printDesc = res.printDesc;
    });
  }

  /**
   * 保存集团顾客试穿和导购出样相关配置信息
   * @return null
   */
  public onSaveGroupConfig(): void {
    const postParams = {
      moduleType: 3, // 1：试穿设置，2：出样设置，3：其他设置
      printDesc: this.extendedSettingForm.printDesc,
    };
    IPSService.saveGroupConfig({ postParams }).then((res) => {
      if (res.ret) {
        this.$message.success('保存成功');
      } else {
        this.$message.error('保存失败');
      }
    });
  }

  /* 周期 */

  /**
   * 当组建创建时
   */
  public created() {
    this.getGroupConfig(); // 获取集团顾客试穿和导购出样配置信息
  }
}
